/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUserShield: {
  name: 'user-shield';
  data: string;
} = {
  name: 'user-shield',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM5 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4 8a5 5 0 0 0-5 5 1 1 0 1 1-2 0 7 7 0 1 1 14 0 1 1 0 1 1-2 0 5 5 0 0 0-5-5ZM19.944 3.372a2 2 0 0 0-1.888 0l-1 .535c-.623.334-1.12 1.042-1.009 1.892.214 1.64 1.105 2.803 1.703 3.42.69.714 1.81.714 2.5 0 .598-.617 1.489-1.78 1.703-3.42.11-.85-.386-1.558-1.009-1.892l-1-.535ZM19 7.623c-.387-.45-.816-1.123-.954-1.977L19 5.134l.954.512c-.138.854-.567 1.526-.954 1.977Z" fill="currentColor"/></svg>`,
};
